/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * 名前はロゴ（`KAKURO` / カックロ）に合わせた。
 * ⚠️ **`nanpure` と紛らわしくないか**を検討した上での `kakuro` である。
 *   どちらも 1..9 を置く数字パズルだが、ナンプレは「行・列・ブロックに1回ずつ」、
 *   こちらは「並びの和が手がかりと一致し、並びの中で数字が重複しない」で
 *   遊びの中心が別（配置の一意性 vs 和の分解）。表示名も別なので利用者から見て衝突しない。
 */
export const GAME_KEY = 'kakuro';
